import React from 'react';
import { Button, Modal } from '@scale/scaleui';
import RemotasksExternalLink from 'react-scale/corp/components/UI/RemotasksExternalLink';
import theme from 'design-system/product/theme';

interface OpenChatBenchmarkModalProps {
  open: boolean;
  onClose: () => void;
  scenarioId: string;
  previewType?: BenchmarkPreviewType;
}

export enum BenchmarkPreviewType {
  Training = 'training',
  Tasks = 'tasks',
}

const OpenChatBenchmarkModal: React.FC<OpenChatBenchmarkModalProps> = ({
  open,
  onClose,
  scenarioId,
  previewType = BenchmarkPreviewType.Training,
}) => {
  return (
    <Modal open={open} onClose={onClose} title={'Open Benchmark'}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: theme.spacing(2),
        }}
      >
        <span style={{ width: '400px' }}>
          You can open the benchmark in the default way, which will pick either attempt (L-1) or
          review (L0) depending on the field benchmark.isAttempterBenchmark.
        </span>
        <RemotasksExternalLink
          path={
            previewType === BenchmarkPreviewType.Training
              ? `/training?trainingId=${scenarioId}`
              : `/tasks?scenarioId=${scenarioId}`
          }
        >
          <Button onClick={() => {}}>[Remo] Open Benchmark in L-1/L0 (attempt or review)</Button>
        </RemotasksExternalLink>
        <RemotasksExternalLink
          isOutlier={true}
          path={
            previewType === BenchmarkPreviewType.Training
              ? `/training?trainingId=${scenarioId}`
              : `/tasks?scenarioId=${scenarioId}`
          }
        >
          <Button onClick={() => {}}>[Outlier] Open Benchmark in L-1/L0 (attempt or review)</Button>
        </RemotasksExternalLink>
        <span style={{ width: '400px' }}>
          If the benchmark is meant to be served in L1, you can use this option to preview that.
        </span>
        <RemotasksExternalLink
          path={
            previewType === BenchmarkPreviewType.Training
              ? `/training?trainingId=${scenarioId}&overrideReviewLevel=1`
              : `/tasks?scenarioId=${scenarioId}&overrideReviewLevel=1`
          }
        >
          <Button onClick={() => {}}>[Remo] Open Benchmark in L1</Button>
        </RemotasksExternalLink>
        <RemotasksExternalLink
          isOutlier={true}
          path={
            previewType === BenchmarkPreviewType.Training
              ? `/training?trainingId=${scenarioId}&overrideReviewLevel=1`
              : `/tasks?scenarioId=${scenarioId}&overrideReviewLevel=1`
          }
        >
          <Button onClick={() => {}}>[Outlier] Open Benchmark in L1</Button>
        </RemotasksExternalLink>
        <span style={{ width: '400px' }}>
          If the benchmark is meant to be served in L4 (consensus reviewer), you can use this option
          to preview that.
        </span>
        <RemotasksExternalLink
          path={
            previewType === BenchmarkPreviewType.Training
              ? `/training?trainingId=${scenarioId}&overrideReviewLevel=4`
              : `/tasks?scenarioId=${scenarioId}&overrideReviewLevel=4`
          }
        >
          <Button onClick={() => {}}>[Remo] Open Benchmark in L4 (consensus review)</Button>
        </RemotasksExternalLink>
        <RemotasksExternalLink
          isOutlier={true}
          path={
            previewType === BenchmarkPreviewType.Training
              ? `/training?trainingId=${scenarioId}&overrideReviewLevel=4`
              : `/tasks?scenarioId=${scenarioId}&overrideReviewLevel=4`
          }
        >
          <Button onClick={() => {}}>[Outlier] Open Benchmark in L4 (consensus review)</Button>
        </RemotasksExternalLink>
        <span style={{ width: '400px' }}>
          If the benchmark is meant to be served in L10 (corp reviewer), you can use this option to
          preview that.
        </span>
        <RemotasksExternalLink
          path={
            previewType === BenchmarkPreviewType.Training
              ? `/training?trainingId=${scenarioId}&overrideReviewLevel=10`
              : `/tasks?scenarioId=${scenarioId}&overrideReviewLevel=10`
          }
        >
          <Button onClick={() => {}}>[Remo] Open Benchmark in L10 (corp review)</Button>
        </RemotasksExternalLink>
        <RemotasksExternalLink
          isOutlier={true}
          path={
            previewType === BenchmarkPreviewType.Training
              ? `/training?trainingId=${scenarioId}&overrideReviewLevel=10`
              : `/tasks?scenarioId=${scenarioId}&overrideReviewLevel=10`
          }
        >
          <Button onClick={() => {}}>[Outlier] Open Benchmark in L10 (corp review)</Button>
        </RemotasksExternalLink>
      </div>
    </Modal>
  );
};

export default OpenChatBenchmarkModal;
